/**
 * Theme Constants
 *
 * Central location for all hardcoded styling values used throughout the application.
 * This file provides a single source of truth for colors, spacing, transitions, etc.
 */

// User defaults
export const DEFAULT_USER_COLOR = '#2a9d8f';

// Common spacing values (used with theme.spacing())
export const SPACING = {
  dialogPadding: { xs: 2, sm: 3 },
  cardPadding: { xs: 2, sm: 3 },
  modalPadding: { xs: 2, sm: 3 },
  sectionPadding: { xs: 2, sm: 3 },
};

// Border radius values (supplement theme.shape)
export const RADIUS = {
  none: 0,
  sm: 4,
  md: 8,
  lg: 12,
  xl: 16,
  xxl: 24,
  full: 9999,
};

// Transition durations (in milliseconds)
export const TRANSITIONS = {
  fast: 150,
  normal: 200,
  slow: 300,
  verySlow: 500,
};

// Z-index layers
export const Z_INDEX = {
  drawer: 1200,
  appBar: 1100,
  modal: 1300,
  tooltip: 1500,
  snackbar: 1400,
};

// Common opacity values
export const OPACITY = {
  disabled: 0.38,
  hover: 0.04,
  selected: 0.08,
  focus: 0.12,
};
